import { render, staticRenderFns } from "./EmSppRequisitionDetSrdList.vue?vue&type=template&id=504c6a65&"
import script from "./EmSppRequisitionDetSrdList.vue?vue&type=script&lang=js&"
export * from "./EmSppRequisitionDetSrdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports